import { createApp } from "vue";
import App from "./App.vue";
import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import tr from "./locales/tr.json";
import de from "./locales/de.json";

import router from "./router";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import * as labsComponents from "vuetify/labs/components";
import colors from "vuetify/lib/util/colors";
import "@mdi/font/css/materialdesignicons.css";
import "sweetalert2/src/sweetalert2.scss";
import BaseLayoutComp from "@/components/MainComponents/BaseLayoutComp";
const vuetify = createVuetify({
  components: {
    ...components,
    ...labsComponents,
  },
  directives,
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          greyLogin: colors.grey.lighten5,
        },
      },
    },
  },
});
import { createPinia } from "pinia";
import { useI18nStore } from "@/stores/i18nStore";
import piniaPersist from "pinia-plugin-persist";
const pinia = createPinia();
pinia.use(piniaPersist);
const i18nStore = useI18nStore(pinia);
const i18n = createI18n({
  locale: i18nStore.locale, // Store'dan alınan dil
  fallbackLocale: "en", // Yedek dil
  messages: {
    en,
    tr,
    de,
  },
});
const app = createApp(App);
app.use(router);
app.use(vuetify);
app.use(pinia);
app.use(i18n);
app.component("BaseLayoutComp", BaseLayoutComp);
app.mount("#app");
